"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDisplayPreference = exports.removeDisplayPreference = exports.getDisplayPreferences = void 0;

var _displayPreferencesActionKeys = _interopRequireDefault(require("./displayPreferencesActionKeys"));

var getDisplayPreferences = function getDisplayPreferences() {
  return {
    type: _displayPreferencesActionKeys.default.GET_DISPLAY_PREFERENCES
  };
};

exports.getDisplayPreferences = getDisplayPreferences;

var removeDisplayPreference = function removeDisplayPreference(key) {
  return {
    type: _displayPreferencesActionKeys.default.REMOVE_DISPLAY_PREFERENCE,
    payload: {
      key: key
    }
  };
};

exports.removeDisplayPreference = removeDisplayPreference;

var setDisplayPreference = function setDisplayPreference(key, value) {
  return {
    type: _displayPreferencesActionKeys.default.SET_DISPLAY_PREFERENCE,
    payload: {
      key: key,
      value: value
    }
  };
};

exports.setDisplayPreference = setDisplayPreference;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/displayPreferences/displayPreferencesActions.js
// module id = 1385
// module chunks = 25